// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3veru","type":"styles_type__3Ie-k","choices":"styles_choices__3e8LI"};